// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"58ebf9e6","732":"80e81168","977":"7e45cd5c"}[chunkId] + ".chunk.js";
};